import { createStore } from 'redux';
const queryString = window.location.search;
const urlParams = new URLSearchParams( queryString );
const sitesGrid = document.getElementById( 'astra-sites-grid' );

const enabledPagination =
	sitesGrid?.getAttribute( 'data-pagination' ) !== 'false' ? true : false;
const pageSize = parseInt( sitesGrid?.getAttribute( 'data-page-size' ) ) || 20;
const pattern = sitesGrid?.getAttribute( 'data-pattern' ) || '';
const enabledInternalRedirect =
	sitesGrid?.getAttribute( 'data-internal-redirect' ) !== 'false' ? true : false;
const enabledShowExcerpt =
	sitesGrid?.getAttribute( 'data-show-excerpt' ) !== 'false' ? true : false;
const searchTerm = urlParams.get( 'search' ) || '';
const pageBuilder =
	AstraShowcaseVars.page_builder ||
	urlParams.get( 'page-builder' ) ||
	sitesGrid?.getAttribute( 'data-page-builder' ) ||
	'elementor';
const showTopSearchFilter = document.querySelector( '#astra-sites-top-searches' );
const showOtherFilters = document.querySelector( '#astra-sites-filters' );
const showDirectoryFilters = document.querySelector(
	'#astra-sites-directory-search-box'
);
const showLiveCounter = document.querySelector(
	'#astra-sites-evergreen-counter'
);
const initialCounterValue = showLiveCounter ? showLiveCounter?.getAttribute( 'data-value' ) : '';
const showHeader = document.querySelector( '#astra-sites-header' );
const showSearchBox = document.querySelector( '#astra-sites-search-box' );

export const initialState = {
	searchTerm,
	pageBuilder,
	filterplan: urlParams.get( 'type' ) || '',
	filtercategories: urlParams.get( 'category' ) || '',
	filtersortby: 'popular',
	searchInputModified: false,
	showTopSearchFilter: !! showTopSearchFilter,
	showOtherFilters: !! showOtherFilters,
	showDirectoryFilters: !! showDirectoryFilters,
	showHeader: !! showHeader,
	showSearchBox: !! showSearchBox,
	customizerParam:
		AstraShowcaseVars.enable_templates && enabledInternalRedirect
			? ''
			: AstraShowcaseVars.customizerParam,
	hidePagebuilderFilter: !! AstraShowcaseVars.hidePageBuilderFilter,
	showMore: false,
	enabledPagination,
	currentPage: parseInt( AstraShowcaseVars.currentPage ),
	pageSize,
	pattern,
	stEnableTemplates:
		AstraShowcaseVars.enable_templates && enabledInternalRedirect
			? true
			: false,
	selectedMegaMenu: '',
	siteBusinessType: '',
	enabledShowExcerpt,
	showLiveCounter: !! showLiveCounter,
	initialCounterValue: parseInt( initialCounterValue ),
};

const changeState = ( state = initialState, { type, ...rest } ) => {
	switch ( type ) {
		case 'set':
			return { ...state, ...rest };
		default:
			return state;
	}
};

const store = createStore( changeState );
export default store;
